import { Box, Button, Stack, Typography } from "@mui/material";
import { FC, ReactNode } from "react";

type StepLayoutContainerProps = {
  children: ReactNode;
  title?: string;
  description?: string;
  onClickNext?: () => void;
  onClickBack?: () => void;
  renderActionButtons?: ReactNode;
  marginXSBottom?: number;
  reduceHeightTOP?: number;
  nextButtonText?: string;
  backButtonText?: string;
  /**
   * Let the page own the only scrollbar instead of scrolling inside the step.
   * The action bar then sticks to the bottom of the viewport.
   */
  fullPageScroll?: boolean;
};
export const StepLayoutContainer: FC<StepLayoutContainerProps> = ({
  children,
  title,
  description,
  onClickNext,
  onClickBack,
  renderActionButtons,
  nextButtonText,
  backButtonText,
  fullPageScroll = true,
}) => {
  return (
    <Box
      py={2}
      px={{ sm: 4, xs: 4 }}
      sx={{
        height: fullPageScroll
          ? "auto"
          : {
              sm: `calc(100dvh - ${onClickBack ? 10 : 10}rem)`,
              xs: `calc(100dvh - ${onClickBack ? 12.5 : 12.5}rem)`,
            },
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        pb={fullPageScroll ? 2 : 12}
        sx={{
          flex: 1,
          overflowY: fullPageScroll ? "visible" : "auto",
        }}
      >
        <Box pb={1}>
          <Typography variant="h5" component="h3">
            {title}
          </Typography>
          {description && (
            <Box mt={1}>
              <Typography variant="body2">{description}</Typography>
            </Box>
          )}
        </Box>
        {children}
      </Box>
      <Box
        px={{ sm: 4, xs: 4 }}
        py={2}
        mx={fullPageScroll ? { sm: -4, xs: -4 } : 0}
        sx={{
          position: fullPageScroll ? "sticky" : "absolute",
          bottom: 0,
          ...(fullPageScroll ? {} : { left: 0, right: 0 }),
          backgroundColor: "white",
          borderTop: "1px solid #e0e0e0",
          zIndex: 1,
        }}
      >
        {renderActionButtons && <Box mb={2}>{renderActionButtons}</Box>}
        <Stack direction="row" spacing={2}>
          {onClickBack ? (
            <Button
              variant="outlined"
              color="primary"
              onClick={onClickBack}
              fullWidth
              size="small"
            >
              {backButtonText || "Go Back"}
            </Button>
          ) : (
            <Box />
          )}
          {!renderActionButtons && (
            <Button
              variant="contained"
              color="primary"
              onClick={onClickNext}
              fullWidth
              size="small"
            >
              {nextButtonText || "Continue / Skip this step"}
            </Button>
          )}
        </Stack>
      </Box>
    </Box>
  );
};
